import type { ReactNode } from 'react';

import { AxisLabel, Tick, TickContainer, TicksContainer } from './Axis.styled';

export type TickElement = {
  name: number | string;
  component: ReactNode;
};

export function Axis({
  alignToGrid = true,
  chartWidth,
  className,
  direction,
  gridLines,
  ticks,
  tickSpace = 0,
  animationStages,
  duration,
  label,
  type,
}: {
  alignToGrid?: boolean;
  chartWidth: number;
  className?: string;
  direction: 'x' | 'y';
  gridLines: number;
  tickSpace?: number;
  ticks: TickElement[];
  animationStages?: Record<string | number, string>;
  duration?: number;
  label?: string;
  type: 'category' | 'range';
}) {
  return (
    <div className={className}>
      {label ? <AxisLabel>{label}</AxisLabel> : null}
      <TicksContainer $type={type}>
        {ticks.map((tick: TickElement, index: number) => (
          <TickContainer
            $alignToGrid={alignToGrid}
            $chartWidth={chartWidth}
            $direction={direction}
            $justifyEnd={!alignToGrid}
            $numberOfTicks={ticks.length}
            $offset={alignToGrid ? [10, 12] : [0, 0]}
            $tickSpace={tickSpace}
            $hasLabel={Boolean(label)}
            $gridLines={gridLines}
            $index={index}
            key={tick.name}
          >
            <Tick
              qaId="axis-tick"
              $lineClamp={2}
              $stage={animationStages ? animationStages[tick.name] : 'enter'}
              $duration={duration}
              $type={type}
            >
              {tick.component}
            </Tick>
          </TickContainer>
        ))}
      </TicksContainer>
    </div>
  );
}
